import { noop } from '@belong/common';
import { Checkbox, Money } from '@belong/ui';
import { getFeeLabel } from 'pages/Accounts/Pages/YourHome/Rent/PayNow/pay-now-utils';

type CreditCardFeeBalanceRowProps = {
  amount: number;
};

export function CreditCardFeeBalanceRow({
  amount,
}: CreditCardFeeBalanceRowProps) {
  return (
    <div className="flex items-center justify-between rounded-small border border-light-gray py-xs">
      <Checkbox
        id="failed-payment-credit-card-fee"
        checked
        disabled
        label={getFeeLabel('CreditCard')}
        onChange={noop}
      />
      <Money
        value={amount}
        format="DOLLARS_WITH_CENTS"
        className="text-body font-semibold"
      />
    </div>
  );
}
